export const withLog = async (fn) => {
  try {
    const data = await fn();
    return data;
  } catch (error) {
    console.error('error', error);
  }
};
